import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, PanInfo } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
const slides = ['https://cdn.magicpatterns.com/uploads/nU5AWuH59NQgn455bjEgq8/ChatGPT_Image_20_may_2026,_01_02_53.png', 'https://cdn.magicpatterns.com/uploads/1JxcsvYk9kZzHWtFCMjYS2/ChatGPT_Image_20_may_2026,_01_05_37.png', 'https://cdn.magicpatterns.com/uploads/pQyw5GkRz8ovxPx3pDFjVL/ChatGPT_Image_20_may_2026,_01_06_43.png', 'https://cdn.magicpatterns.com/uploads/rfW1yF73EdPqBWqnvx2vVN/ChatGPT_Image_20_may_2026,_01_07_50.png'];
export function HeroSection() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(id);
  }, []);
  const handleDragEnd = (_: any, info: PanInfo) => {
    const threshold = 50;
    if (info.offset.x < -threshold) {
      setIndex(prev => (prev + 1) % slides.length);
    } else if (info.offset.x > threshold) {
      setIndex(prev => (prev - 1 + slides.length) % slides.length);
    }
  };
  return <section className="w-full bg-[#110038] py-24 md:py-32 relative overflow-hidden" data-id="element-214">
      {/* Purple Mesh Gradient Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-215">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-[#7C3AED] opacity-20 blur-[120px]" data-id="element-216"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-[#4C1D95] opacity-30 blur-[150px]" data-id="element-217"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-218">
        <div className="flex flex-col md:flex-row items-center gap-16 md:gap-12" data-id="element-219">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 text-center md:text-left order-1" data-id="element-220">
            {/* Material digital badge */}
            <div className="inline-flex items-center gap-2 bg-[#7C3AED]/20 border border-[#7C3AED]/40 text-[#C4B5FD] px-4 py-1.5 rounded-full text-xs font-bold tracking-wider uppercase mb-6 font-sans" data-id="element-221">
              <FileTextIcon className="w-3.5 h-3.5 text-[#E5A83B]" data-id="element-222" />
              Material digital · PDF
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight font-serif" data-id="element-223">
              Dejen de pelear por todo y{' '}
              <span className="text-[#E5A83B]" data-id="element-224">salven</span> su relación antes
              de que sea demasiado tarde
            </h1>

            <p className="text-sm md:text-base text-[#C4B5FD] font-bold tracking-wide uppercase mb-6 font-sans flex items-center justify-center md:justify-start gap-2" data-id="element-225">
              <span className="text-lg" data-id="element-226">👉</span> 20 páginas. Sin relleno. Solo
              el protocolo exacto para los próximos 7 días.
            </p>

            <p className="text-lg md:text-xl text-[#A78BFA] mb-10 leading-relaxed font-sans" data-id="element-227">
              Descubrí el protocolo de supervivencia emocional diseñado para
              frenar las discusiones diarias, evitar que el estrés externo
              destruya el vínculo y reactivar la intimidad, incluso si sienten
              que la rutina y el cansancio ya les ganaron.
            </p>

            {/* CTA Button */}
            <motion.a href="#oferta-final" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(245, 197, 24, 0)', '0 0 0 18px rgba(245, 197, 24, 0.25)', '0 0 0 0 rgba(245, 197, 24, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="inline-block w-full md:w-auto bg-[#F5C518] text-black px-10 py-5 rounded-xl text-xl font-extrabold shadow-[0_10px_30px_-5px_rgba(245,197,24,0.5)] hover:bg-[#e6b800] transition-colors mb-6 text-center font-sans tracking-wide" data-id="element-228">
              ✅ SÍ, QUIERO SALVAR MI RELACIÓN
            </motion.a>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 text-xs md:text-sm text-[#C4B5FD] font-sans mb-8" data-id="element-229">
              <div className="flex items-center gap-1.5" data-id="element-230">
                <DownloadIcon className="w-4 h-4 text-[#E5A83B]" data-id="element-231" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-1.5" data-id="element-232">
                <ShieldCheckIcon className="w-4 h-4 text-[#E5A83B]" data-id="element-233" />
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-234">
                <FileTextIcon className="w-4 h-4 text-[#E5A83B]" data-id="element-235" />
                PDF
              </div>
            </div>

            <div className="text-center md:text-left text-[#A78BFA] text-sm animate-bounce mt-4" data-id="element-236">
              👇 <em data-id="element-237">Seguí leyendo para ver cómo funciona...</em>
            </div>
          </motion.div>

          {/* Right: iPad Carousel */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 flex flex-col items-center order-2" data-id="element-238">
            {/* Micro-copy ABOVE the carousel */}
            <p className="text-center text-sm md:text-base font-bold text-[#C4B5FD] mb-6 tracking-wide font-sans px-4" data-id="element-239">
              Esto es exactamente lo que vas a recibir en tu dispositivo:
            </p>

            {/* Carousel container — iPad landscape ratio (3:2) */}
            <div className="relative w-full max-w-[560px] overflow-hidden select-none" style={{
            aspectRatio: '3 / 2'
          }} data-id="element-240">
              <AnimatePresence mode="wait" data-id="element-241">
                <motion.div key={index} initial={{
                opacity: 0,
                x: 40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -40
              }} transition={{
                duration: 0.5,
                ease: 'easeOut'
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.2} onDragEnd={handleDragEnd} className="absolute inset-0 cursor-grab active:cursor-grabbing" data-id="element-242">
                  <img src={slides[index]} alt={`Demostración del producto — vista ${index + 1}`} className="w-full h-full object-contain pointer-events-none" draggable={false} data-id="element-243" />
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Dots */}
            <div className="flex items-center justify-center gap-2.5 mt-6" data-id="element-244">
              {slides.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir a la diapositiva ${i + 1}`} className={`transition-all duration-300 rounded-full ${i === index ? 'w-8 h-2.5 bg-[#E5A83B]' : 'w-2.5 h-2.5 bg-[#C4B5FD]/30 hover:bg-[#C4B5FD]/50'}`} data-id="element-245" />)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}